import React, { useState, useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    Alert,
    Button,
    Container,
    Form,
    Row,
    Col,
    Nav,
    NavLink,
    TabContent,
    TabPane,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    FormGroup,
    Label,
    Input,
} from 'reactstrap';
import classnames from 'classnames';
import { debounce } from 'debounce';

import * as actions from '../actions/Program';
import * as staticDataActions from '../actions/StaticData';

import {
    clearSearchedPersons,
    getEditContact,
    getPerson,
    searchPersons,
    setFromAddButton,
    clearEditContactDetails,
} from '../actions/Person';

import { getJurisdictions } from '../actions/Jurisdictions';
import { getGrants, searchGrants } from '../actions/Grants';
import { getProgram, setLocation } from '../actions/Programs';
import { getTraining } from '../actions/Trainings';
import { getUsersByRole } from '../actions/Users';
import { getTrainingFaculty } from '../actions/Training';

import POCList from '../components/poc/List';
import POCModal from '../components/poc/Modal';
import POCEdit from '../components/poc/EditContact';

import Documents from '../components/documents/Documents';
import GridHeader from '../components/common/GridHeader';
import { apiGet } from '../utils/Api';
import Journal from '../components/common/Journal';
import CourtTypes from '../components/common/LookupDropDown';
import Jurisidctions from '../components/common/JurisdictionDropDown';
import Users from '../components/common/UserDropDown';
import Breadcrumb from '../components/MainMenuBreadcrumb';
import TrainingList from '../components/training/TrainingList';
import GrantsList from '../components/common/GrantsList';
import GrantsSearch from '../components/common/GrantsSearch';
import AddGrant from '../components/common/AddGrant';
import Address from '../components/common/Address';

const Program = (props) => {
    const [state, setState] = useState({
        addButtonClicked: false,
        activeTab: null,
        showPOCAdd: false,
        showGrantsSearch: false,
        disableGrantsDelete: true,
        grantId: null,
        confirmModal: false,
        setToPrimaryModal: false,
        selectedContactId: null,
        contactDisplayName: null,
        dropdownOpen: false,
        selectedUser: null,
        projectDirectorId: null,
        trainingCoordinatorId: null,
        secondaryProjectDirectorId: null,
        additionalContactId: null,
        courtHearingDate: null,
        staffingDate: null,
        projectStartDate: null,
        projectEndDate: null,
        showEndDateBeforeStart: false,
        showAddGrant: null,
        programContactId: null,
        showPOCEdit: false,
    });

    const selectedGrantIds = useRef([]);
    const throttledSearchRef = useRef(null);

    const formatCourtHearingDateForDisplay = (value) => {
        console.log('value', value)
        if (!value) return '';
        return String(value).substring(0, 10);
    };

    const formatStaffingDateForDisplay = (value) => {
        console.log('VALUE', value)
        if (!value) return '';
        return String(value).substring(0, 10);
    };

    // Throttled search for grants
    useEffect(() => {
        throttledSearchRef.current = debounce((programId, searchTerm) => {
            if (props.actions.searchGrants) {
                props.actions.searchGrants(programId, searchTerm);
            }
        }, 500);
    }, [props.actions]);

    // Load static data and choose initial tab
    useEffect(() => {
        const {
            getCourtTypes,
            getGrantTypes,
            getPhoneTypes,
            getGenerations,
            getProperTitles,
            getPersonTypes,
            getStates,
            getUsersByRole: getUsersByRoleAction,
            getJurisdictions: getJurisdictionsAction,
            getAddressTypes,
        } = props.actions;

        getCourtTypes();
        getGrantTypes();
        getPhoneTypes();
        getGenerations();
        getProperTitles();
        getPersonTypes();
        getStates();
        getJurisdictionsAction();
        getAddressTypes();
        getUsersByRoleAction('');

        if (props.history.location.state && props.history.location.state.newProgram === true) {
            setState((prev) => ({ ...prev, activeTab: 'Info' }));
        } else if (props.location.state?.programId) {
            setState((prev) => ({ ...prev, activeTab: 'Grants' }));
        } else {
            setState((prev) => ({ ...prev, activeTab: 'Notes' }));
        }
    }, []);

    // Load program-related tabs data when navigating in with an id
    useEffect(() => {
        const { id } = props.location.state || {};
        if (id !== undefined) {
            props.actions.getProgramJournal(id);
            props.actions.getProgramContacts(id);
        }
    }, [props.location.state?.id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        props.actions.setField(name, value);
    };

    const handleProjectDirectorDDChange = (e) => {
        const { value } = e.target;
        setState((prev) => ({ ...prev, projectDirectorId: value }));
        props.actions.setField('projectDirectorId', value);
    };

    const handleTrainingCoordinatorDDChange = (e) => {
        const { value } = e.target;
        setState((prev) => ({ ...prev, trainingCoordinatorId: value }));
        props.actions.setField('trainingCoordinatorId', value);
    };

    const handleSecondaryProjectDirectorDDChange = (e) => {
        const { value } = e.target;
        setState((prev) => ({ ...prev, secondaryProjectDirectorId: value }));
        props.actions.setField('secondaryProjectDirectorId', value);
    };

    const handleAdditionalContactDDChange = (e) => {
        const { value } = e.target;
        setState((prev) => ({ ...prev, additionalContactId: value }));
        props.actions.setField('additionalContactId', value);
    };

    const handleAddressChange = (name, value) => {
        props.actions.setAddressField(name, value);
    };

    const handlePhoneChange = (value) => {
        props.actions.setPhoneField(value);
    };

    const handleGrantDDChange = (e) => {
        const { name, value } = e.target;
        props.actions.setField(name, value);
        setState((prev) => ({ ...prev, grantId: value }));
    };

    const handleSave = (start, end) => {
        if (start && end && end < start) {
            setState((prev) => ({ ...prev, showEndDateBeforeStart: true }));
            return;
        }
        props.actions.updateProgram(props.program);
    };

    const handleAddFiles = (type, files) =>
        props.actions.addProgramDocument(
            props.program.get('programId'),
            type || props.documentTypes[0].lookupId,
            files
        );

    const handleDocumentDelete = (ids) => props.actions.deleteProgramDocuments(props.program.get('programId'), ids);

    const handleDocumentSave = (programDocumentId, documentTypeId) =>
        props.actions.updateProgramDocument(props.programId, programDocumentId, documentTypeId);

    const handleToggleTab = (tab) => {
        const idFromProgram = props.program.get('programId');

        if (tab === 'Documents') {
            props.actions.getProgramDocuments(idFromProgram);
            props.actions.getProgramDocumentTypes();
        }

        if (tab === 'Contacts') {
            props.actions.getProgramContacts(idFromProgram);
        }

        if (tab === 'Grants') {
            props.actions.getProgramGrants(idFromProgram);
        }

        if (tab === 'Info') {
            props.actions.getProgram(idFromProgram);
        }

        if (tab === 'Notes') {
            props.actions.getProgramJournal(idFromProgram);
        }

        if (tab === 'Trainings') {
            props.actions.getProgramTrainings(props.currentSessionId, idFromProgram);
        }

        setState((prev) => ({ ...prev, activeTab: tab }));
    };

    const handleTogglePOCAdd = () => {
        props.actions.setFromAddButton();
        setState((prev) => ({ ...prev, showPOCAdd: !prev.showPOCAdd }));
    };

    const handleTogglePOCEdit = () => {
        setState((prev) => ({ ...prev, showPOCEdit: !prev.showPOCEdit }));
    };

    const handleDeleteContacts = (ids) => props.actions.deleteProgramContacts(props.program.get('programId'), ids);

    const handleAddContact = (contact) => {
        const programId = props.program.get('programId');
        const fromEdit = contact.fromEdit === true;

        if (fromEdit) {
            props.actions.addProgramContact(programId, {
                isPrimary: contact.isPrimary,
                programContactId: state.programContactId,
                programId,
                person: contact,
                isActive: true,
            });
        } else {
            props.actions.addProgramContact(programId, { programId, person: contact, isActive: true });
        }

        setState((prev) => ({ ...prev, programContactId: null }));
    };

    const handleGrantsOnSelectionChanged = (ids) => {
        selectedGrantIds.current = ids;
        setState((prev) => ({ ...prev, disableGrantsDelete: ids.length === 0 }));
    };

    const handleAddContactFromSearch = (persons) => {
        const programId = props.program.get('programId');
        const contacts = persons.map((x) => ({
            programId,
            personId: x.personId,
            isActive: true,
        }));

        props.actions.addProgramContacts(programId, contacts);
    };

    const handleGrantSearchToggle = () => {
        if (props.actions.clearSearchedGrants) {
            props.actions.clearSearchedGrants();
        }
        setState((prev) => ({ ...prev, showGrantsSearch: !prev.showGrantsSearch }));
    };

    const handleGrantsSearchOnAdd = (grantIds) => {
        props.actions.addProgramGrants(props.program.get('programId'), grantIds);
    };

    const handleGrantsOnDelete = () => {
        props.actions.deleteProgramGrants(props.program.get('programId'), selectedGrantIds.current);
        setState((prev) => ({ ...prev, disableGrantsDelete: true }));
    };

    const handlePersonSelect = (id) => {
        props.actions.getPerson(id);
        props.history.push(`/persons/person/${id}`);
    };

    const setProgramContactId = async (id) => {
        setState((prev) => ({ ...prev, programContactId: id }));
    };

    const makePrimary = async (params) => {
        if (params.row.isPrimary === true) {
            setState((prev) => ({
                ...prev,
                confirmModal: true,
                selectedContactId: params.row.programContactId,
                contactDisplayName: params.row.displayName,
            }));
        } else {
            setState((prev) => ({
                ...prev,
                setToPrimaryModal: true,
                selectedContactId: params.row.programContactId,
                contactDisplayName: params.row.displayName,
            }));
        }
    };

    const handleSaveProgramJournalEntry = (journalEntry) => {
        const programId = props.program.get('programId');
        const programJournalEntry = journalEntry.id
            ? {
                programId,
                programJournalEntryId: journalEntry.id,
                isActive: true,
                ...journalEntry,
            }
            : {
                programId,
                isActive: true,
                ...journalEntry,
            };
        return props.actions.saveProgramJournalEntry(programId, programJournalEntry);
    };

    const handleGetProgramJournalEntry = (programJournalEntryId) =>
        apiGet(`${process.env.REACT_APP_API_HOST}api/program/journal/${programJournalEntryId}`).then((res) => ({
            ...res,
            id: res.programJournalEntryId,
        }));

    const handleDeleteProgramJournalEntries = (ids) =>
        props.actions.deleteProgramJournalEntries(props.program.get('programId'), ids);

    const handleTrainingOnSelect = (trainingId) => {
        props.actions.getTraining(trainingId);
        props.actions.getTrainingFaculty(trainingId);
        props.history.push({
            pathname: `/trainings/training/${trainingId}`,
        });
    };

    const handleAddGrantToggle = () => {
        if (props.actions.clearSearchedGrants) {
            props.actions.clearSearchedGrants();
        }
        setState((prev) => ({ ...prev, showAddGrant: !prev.showAddGrant }));
    };

    const handleGrantSearch = (text) => {
        const { programId } = props.program.toJS();
        if (throttledSearchRef.current) {
            throttledSearchRef.current(programId, text);
        }
    };

    const handleGrantDoubleClick = (e) => {
        props.history.push({
            pathname: `/grants/grant/${e.id}`,
            state: { fromProgramId: props.program.get('programId') },
        });
    };

    const handleCourtHearingDateChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({ ...prev, [name]: value }));
        props.actions.setField(name, value);
    };

    const handleStaffingDateChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({ ...prev, [name]: value }));
        props.actions.setField(name, value);
    };

    const handleProjectStartDateChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({ ...prev, [name]: value }));
        props.actions.setField(name, value);
    };

    const handleProjectEndDateChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({ ...prev, [name]: value }));
        props.actions.setField(name, value);
    };

    const onDismissShowEndDateBeforeStartDate = () => {
        setState((prev) => ({ ...prev, showEndDateBeforeStart: !prev.showEndDateBeforeStart }));
    };

    const handdleTogglePocListFromAdd = () => {
        props.actions.setFromAddButton(true);
        setState((prev) => ({ ...prev, showPOCAdd: true }));
    };

    const onEdit = (id) => {
        props.actions.setFromAddButton(false);
        props.actions.getEditContact(id).then(() => {
            setState((prev) => ({ ...prev, showPOCEdit: true }));
        });
    };

    const {
        addressTypes,
        contactNameIsValid,
        contactPhoneIsValid,
        contactPersonTypeIsValid,
        phoneTypes,
        users,
        states,
        documents,
        program,
        courtTypes,
        jurisdictions,
        programDataContacts,
        generations,
        properTitles,
        personTypes,
        personSearchResults,
        journal,
    } = props;

    const raw = program.toJS();
    const {
        courtTypeId,
        jurisdictionId,
        programId: programIdFromProgram,
        name,
        address,
        trainingCoordinatorId,
        projectDirectorId,
        secondaryProjectDirectorId,
        additionalContactId,
        courtHearingDate,
        staffingDate,
    } = raw;

    const projectStartDateValue = raw.projectStartDate ? String(raw.projectStartDate).substring(0, 10) : '';
    const projectEndDateValue = raw.projectEndDate ? String(raw.projectEndDate).substring(0, 10) : '';

    const doesJurisdictionExist = jurisdictions.filter((e) => e.jurisdictionId === Number(jurisdictionId));
    const jurisdictionValueToUse = doesJurisdictionExist.length > 0 ? jurisdictionId : undefined;

    const filterPrimaryContact =
        programDataContacts && programDataContacts.toJS().filter((e) => e.isPrimary === true);
    const filterPrimaryContactPhone = (filterPrimaryContact && filterPrimaryContact[0]?.phone) || '';
    const filterPrimaryContactName = (filterPrimaryContact && filterPrimaryContact[0]?.displayName) || '';
    const filterPrimaryContectEmail = (filterPrimaryContact && filterPrimaryContact[0]?.email) || '';

    const filteredContacts = personSearchResults.filter((e) => {
        return (
            Array.isArray(e.assignedPrograms) &&
            !e.assignedPrograms.some((p) => p.programId === programIdFromProgram)
        );
    });

    return (
        <Container>
            <div style={{ paddingBottom: '10px' }}>
                <Breadcrumb history={props.history} />
            </div>

            <Alert
                color="warning"
                isOpen={state.showEndDateBeforeStart}
                fade={true}
                toggle={onDismissShowEndDateBeforeStartDate}
            >
                Project end date cannot occur before project start date.
            </Alert>

            <br />

            {state.showPOCAdd && (
                <POCModal
                    modalTitle={'Add a Point of Contact'}
                    toggleValidState={props.actions.toggleValidState}
                    toggleContactPhoneIsValid={props.actions.toggleContactPhoneIsValid}
                    contactPhoneIsValid={contactPhoneIsValid}
                    clearEditContactDetails={props.actions.clearEditContactDetails}
                    contactNameIsValid={contactNameIsValid}
                    contactPersonTypeIsValid={contactPersonTypeIsValid}
                    isOpen={state.showPOCAdd}
                    toggle={handleTogglePOCAdd}
                    states={states}
                    phoneTypes={phoneTypes.toJS()}
                    properTitles={properTitles}
                    generations={generations}
                    personTypes={personTypes}
                    addressTypes={addressTypes.toJS()}
                    onAdd={handleAddContact}
                />
            )}

            {state.showPOCEdit && (
                <POCEdit
                    modalTitle={'Edit a Point of Contact'}
                    toggleValidState={props.actions.toggleValidState}
                    toggleContactPhoneIsValid={props.actions.toggleContactPhoneIsValid}
                    contactPhoneIsValid={contactPhoneIsValid}
                    clearEditContactDetails={props.actions.clearEditContactDetails}
                    contactNameIsValid={contactNameIsValid}
                    contactPersonTypeIsValid={contactPersonTypeIsValid}
                    isOpen={state.showPOCEdit}
                    toggle={handleTogglePOCEdit}
                    states={states}
                    phoneTypes={phoneTypes.toJS()}
                    properTitles={properTitles}
                    generations={generations}
                    personTypes={personTypes}
                    addressTypes={addressTypes.toJS()}
                    onAdd={handleAddContact}
                />
            )}

            <Form>
                <Nav tabs>
                    <NavLink
                        className={classnames({ active: state.activeTab === 'Notes' })}
                        onClick={() => handleToggleTab('Notes')}
                        disabled={!programIdFromProgram}
                    >
                        Journal
                    </NavLink>
                    <NavLink
                        className={classnames({ active: state.activeTab === 'Info' })}
                        onClick={() => handleToggleTab('Info')}
                    >
                        Info
                    </NavLink>
                    <NavLink
                        className={classnames({ active: state.activeTab === 'Contacts' })}
                        onClick={() => handleToggleTab('Contacts')}
                        disabled={!programIdFromProgram}
                    >
                        Contacts
                    </NavLink>
                    <NavLink
                        className={classnames({ active: state.activeTab === 'Grants' })}
                        onClick={() => handleToggleTab('Grants')}
                        disabled={!programIdFromProgram}
                    >
                        Grants
                    </NavLink>
                    <NavLink
                        className={classnames({ active: state.activeTab === 'Documents' })}
                        onClick={() => handleToggleTab('Documents')}
                        disabled={!programIdFromProgram}
                    >
                        Documents
                    </NavLink>
                    <NavLink
                        className={classnames({ active: state.activeTab === 'Trainings' })}
                        onClick={() => handleToggleTab('Trainings')}
                        disabled={!programIdFromProgram}
                    >
                        Trainings
                    </NavLink>
                </Nav>

                <TabContent activeTab={state.activeTab}>
                    <TabPane tabId="Info">
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Name:</Label>
                                    <Input
                                        name="name"
                                        type="text"
                                        invalid={!name}
                                        value={name || ''}
                                        onChange={handleChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <CourtTypes
                                    label="Court Type"
                                    name="courtTypeId"
                                    dropdownPlaceholder="Select"
                                    lookups={courtTypes}
                                    value={courtTypeId}
                                    onChange={handleChange}
                                />
                            </Col>
                            <Col>
                                <Jurisidctions
                                    name="jurisdictionsId"
                                    dropdownPlaceholder="Select"
                                    jurisdictions={jurisdictions}
                                    value={jurisdictionValueToUse}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Address
                                states={props.states}
                                name="address"
                                onChange={handleAddressChange}
                                city={address?.city}
                                stateId={address?.stateId}
                                zipCode={address?.zipCode}
                                line1={address?.line1}
                                line2={address?.line2}
                            />
                        </Row>

                        <Row>
                            <Col>
                                <Users
                                    titleToUse="Project Director"
                                    name="projectDirectorId"
                                    dropdownPlaceholder="Select"
                                    users={users.toJS()}
                                    onChange={handleProjectDirectorDDChange}
                                    value={projectDirectorId}
                                />
                            </Col>
                            <Col>
                                <Users
                                    titleToUse="Training Coordinator"
                                    name="trainingCoordinatorId"
                                    dropdownPlaceholder="Select"
                                    users={users.toJS()}
                                    onChange={handleTrainingCoordinatorDDChange}
                                    value={trainingCoordinatorId}
                                />
                            </Col>
                        </Row>

                        <br />

                        <Row>
                            <Col>
                                <Users
                                    titleToUse="Secondary Project Director"
                                    name="secondaryProjectDirectorId"
                                    dropdownPlaceholder="Select"
                                    users={users.toJS()}
                                    onChange={handleSecondaryProjectDirectorDDChange}
                                    value={secondaryProjectDirectorId}
                                />
                            </Col>
                            <Col>
                                <Users
                                    titleToUse="Additional Contact"
                                    name="additionalContactId"
                                    dropdownPlaceholder="Select"
                                    users={users.toJS()}
                                    onChange={handleAdditionalContactDDChange}
                                    value={additionalContactId}
                                />
                            </Col>
                        </Row>

                        <Row style={{ paddingTop: '1em' }}>
                            <Col>
                                <Label>Primary Contact:</Label>
                                <br />
                                <Label>{filterPrimaryContactName}</Label>
                            </Col>
                            <Col>
                                <Label>Primary Phone:</Label>
                                <br />
                                <Label>{filterPrimaryContactPhone}</Label>
                            </Col>
                            <Col>
                                <Label>Email:</Label>
                                <br />
                                <Label>{filterPrimaryContectEmail}</Label>
                            </Col>
                        </Row>

                        <Row style={{ paddingTop: '1em' }}>
                            <Col>
                                <Label style={{ paddingLeft: '5px' }}>Project Start Date:</Label>
                                <Input
                                    type="date"
                                    max="2999-12-31"
                                    name="projectStartDate"
                                    onChange={handleProjectStartDateChange}
                                    value={projectStartDateValue}
                                />
                            </Col>

                            <Col>
                                <Label style={{ paddingLeft: '5px' }}>Project End Date:</Label>
                                <Input
                                    type="date"
                                    max="2999-12-31"
                                    name="projectEndDate"
                                    onChange={handleProjectEndDateChange}
                                    value={projectEndDateValue}
                                />
                            </Col>

                            <Col>
                                <Label style={{ paddingLeft: '5px' }}>Staffing Date:</Label>
                                <Input
                                    type="text"
                                    name="staffingDate"
                                    onChange={handleStaffingDateChange}
                                    value={staffingDate ?? formatStaffingDateForDisplay(staffingDate)}
                                />
                            </Col>

                            <Col>
                                <Label style={{ paddingLeft: '5px' }}>Court Hearing Date:</Label>
                                <Input
                                    type="text"
                                    name="courtHearingDate"
                                    onChange={handleCourtHearingDateChange}
                                    value={courtHearingDate ?? formatCourtHearingDateForDisplay(courtHearingDate)}
                                />
                            </Col>
                        </Row>

                        {state.activeTab === 'Info' && (
                            <Row className="pt-1">
                                <Col>
                                    <Button
                                        className="float-right"
                                        disabled={!courtTypeId || !name || !jurisdictionId}
                                        onClick={() => handleSave(projectStartDateValue, projectEndDateValue)}
                                    >
                                        Save
                                    </Button>
                                </Col>
                            </Row>
                        )}
                    </TabPane>

                    <TabPane tabId="Contacts">
                        <Row className="pt-3">
                            <Col>
                                <POCList
                                    setProgramContactId={setProgramContactId}
                                    fromContactGrid={true}
                                    makePrimary={makePrimary}
                                    data={programDataContacts.toJS()}
                                    programId={programIdFromProgram}
                                    clearSearchedPersons={props.actions.clearSearchedPersons}
                                    onEdit={onEdit}
                                    onAdd={handdleTogglePocListFromAdd}
                                    onDelete={handleDeleteContacts}
                                    onSelect={handlePersonSelect}
                                    onSearch={props.actions.searchPersons}
                                    searchResults={filteredContacts}
                                    onAddFromSearch={handleAddContactFromSearch}
                                />
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tabId="Documents">
                        <Row className="pt-3">
                            <Col>
                                <Documents
                                    title="Program Documents:"
                                    documentTypes={props.documentTypes}
                                    onSave={handleDocumentSave}
                                    onAddFiles={handleAddFiles}
                                    onTypeChange={props.handleDocumentTypeChange}
                                    onDownload={props.handleDocumentDownload}
                                    onDelete={handleDocumentDelete}
                                    data={documents && documents.toJS()}
                                    getEntityId={(x) => x.programDocumentId}
                                />
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tabId="Grants">
                        <Row className="pt-3">
                            <GridHeader
                                gridEntities="Grants"
                                showSearch={true}
                                searchButtonId="searchGrantButton"
                                onSearch={handleGrantSearchToggle}
                                onDeleteClick={handleGrantsOnDelete}
                                disableDelete={state.disableGrantsDelete}
                                addButtonId="addGrantButton"
                                deleteButtonId="deleteGrantButton"
                                onAddClick={handleAddGrantToggle}
                                addTooltipTarget={'addGrantButton'}
                                deleteTooltipTarget={'deleteGrantButton'}
                                tooltipEntity={'Grant'}
                            />
                        </Row>

                        <GrantsList
                            onSelectionChanged={handleGrantsOnSelectionChanged}
                            onRowDoubleClick={handleGrantDoubleClick}
                            data={props.programGrants}
                            programId={programIdFromProgram}
                        />

                        <GrantsSearch
                            onSearch={handleGrantSearch}
                            grants={props.grants}
                            isOpen={state.showGrantsSearch}
                            toggle={handleGrantSearchToggle}
                            onAdd={handleGrantsSearchOnAdd}
                            data={props.searchedGrants}
                        />

                        <AddGrant
                            programId={props.program.get('programId')}
                            onSearch={handleGrantSearch}
                            isOpen={state.showAddGrant}
                            toggle={handleAddGrantToggle}
                            onAdd={handleGrantsSearchOnAdd}
                            data={props.searchedGrants}
                            grantTypes={props.grantTypes}
                            sessionId={props.currentSessionId}
                            setField={props.actions.setField}
                        />
                    </TabPane>

                    <TabPane tabId="Notes">
                        <Row className="pt-3">
                            <Col>
                                <Journal
                                    title=" "
                                    data={journal.toJS()}
                                    onGet={handleGetProgramJournalEntry}
                                    onSave={handleSaveProgramJournalEntry}
                                    onDelete={handleDeleteProgramJournalEntries}
                                    journalTypes={props.journalTypes}
                                    journalStatusTypes={props.journalStatusTypes}
                                    journalRoleTypes={props.journalRoleTypes}
                                />
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tabId="Trainings">
                        <Row className="pt-3">
                            <Col>
                                <TrainingList data={props.trainings} onSelect={handleTrainingOnSelect} />
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </Form>

            <Modal
                isOpen={state.confirmModal}
                toggle={() => setState((prev) => ({ ...prev, confirmModal: false, addButtonClicked: false }))}
                className={props.className}
            >
                <ModalHeader toggle={() => setState((prev) => ({ ...prev, confirmModal: false }))}>
                    Remove Primary Contact
                </ModalHeader>
                <ModalBody>
                    This will remove {state.contactDisplayName} as the primary contact for this program.
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={() => {
                            props.actions.addPrimaryContact(state.selectedContactId, props.program.get('programId'));
                            setState((prev) => ({ ...prev, confirmModal: false }));
                        }}
                    >
                        Ok
                    </Button>
                    <Button color="secondary" onClick={() => setState((prev) => ({ ...prev, confirmModal: false }))}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={state.setToPrimaryModal}
                toggle={() => setState((prev) => ({ ...prev, setToPrimaryModal: false, addButtonClicked: false }))}
                className={props.className}
            >
                <ModalHeader toggle={() => setState((prev) => ({ ...prev, setToPrimaryModal: false }))}>
                    Set Primary Contact
                </ModalHeader>
                <ModalBody>
                    This will set a primary contact to {state.contactDisplayName} for this program.
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={() => {
                            props.actions.addPrimaryContact(state.selectedContactId, props.program.get('programId'));
                            setState((prev) => ({ ...prev, setToPrimaryModal: false }));
                        }}
                    >
                        Ok
                    </Button>
                    <Button
                        color="secondary"
                        onClick={() => setState((prev) => ({ ...prev, setToPrimaryModal: false }))}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

function mapStateToProps(state) {
    return {
        programId: state.ProgramData.getIn(['program', 'programId']),
        addressTypes: state.StaticData.get('addressTypes'),
        contactPhoneIsValid: state.ProgramData.get('phoneNumberIsValid'),
        contactNameIsValid: state.ProgramData.get('contactNameIsValid'),
        contactPersonTypeIsValid: state.ProgramData.get('contactPersonTypeIsValid'),
        program: state.ProgramData.get('program'),
        programDataContacts: state.ProgramData.get('contacts'),
        documents: state.ProgramData.get('documents'),
        journalTypes: state.StaticData.get('journalTypes').toJS(),
        documentTypes: state.StaticData.get('programDocumentTypes').toJS(),
        courtTypes: state.StaticData.get('courtTypes').toJS(),
        journalStatusTypes: state.StaticData.get('journalStatusTypes').toJS(),
        journalRoleTypes: state.StaticData.get('journalRoleTypes').toJS(),
        phoneTypes: state.StaticData.get('phoneTypes'),
        properTitles: state.StaticData.get('properTitles').toJS(),
        generations: state.StaticData.get('generations').toJS(),
        personTypes: state.StaticData.get('personTypes').toJS(),
        states: state.StaticData.get('states').toJS(),
        jurisdictions: state.Jurisdictions.toJS(),
        grants: state.Grants.toJS(),
        fromTrainingPage: state.ProgramData.get('fromTrainingPage'),
        fromTrainingId: state.ProgramData.get('fromTrainingId'),
        person: state.PersonData.get('person').toJS(),
        currentSessionId: parseInt(
            state.login
                .getIn(['context', 'user', 'claims'])
                .find((x) => x.get('claimType') === 'ACT.CurrentSession')
                .get('claimValue'),
            10
        ),
        personSearchResults: state.SearchResults.get('persons').toJS(),
        journal: state.ProgramData.get('journal'),
        trainings: state.ProgramData.get('trainings').toJS(),
        programGrants: state.ProgramData.get('programGrants'),
        searchedGrants: state.ProgramData.get('searchedGrants'),
        users: state.Users.get('userList'),
        grantTypes: state.StaticData.get('grantTypes').toJS(),
        fromAddButton: state.PersonData.get('fromAddButton'),
        grants: state.Grants.toJS(),
        searchedGrants: state.Grants.get('searchedGrants')
            ? state.Grants.get('searchedGrants')
            : state.ProgramData.get('searchedGrants'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...actions,
                ...staticDataActions,
                clearSearchedPersons,
                clearEditContactDetails,
                getTraining,
                getTrainingFaculty,
                getProgram,
                getJurisdictions,
                setLocation,
                searchGrants,
                getGrants,
                getEditContact,
                getPerson,
                searchPersons,
                setFromAddButton,
                getUsersByRole,
            },
            dispatch
        ),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Program);